import { useMemo } from "react";

import { ACCESS_TOKEN, REFRESH_TOKEN } from "@/constants/config/auth";
import { useAppSelector } from "@/hooks/redux";

export const useUserPayload = () => {
    const {
        id: userId,
        firstName,
        lastName,
        phone,
    } = useAppSelector((state) => state.user);

    const userPayload = useMemo(
        () => ({
            userId,
            phone,
            fullname: `${firstName} ${lastName}`,
            accessToken: localStorage.getItem(ACCESS_TOKEN),
            refreshToken: localStorage.getItem(REFRESH_TOKEN),
        }),
        [userId, phone, firstName, lastName],
    );

    return { userPayload };
};
